import * as api from './api';
import * as SurveyApi from './surveyApi';
import * as TrialApi from './trialApi';
import * as InvoiceAndpaymentApi from './invoiceAndPayment';
import * as CertificateApi from './certificate';
import * as ReviewApi from './reviewApi';
import * as UserApi from './userApi';
import * as VoucherApi from './voucherApi';
import * as EnrollmentApi from './EnrollmentApi';
import * as FeedbackApi from './feedbackApi';
import * as InstituteApi from './instituteApi';
import * as GroundTruthApi from './groundTruthApi';
import * as SubmissionApi from './submissionApi';
import * as DigitalTrialApi from './DRTApi';
import * as TrialTagApi from './trialTagApi';
import * as BillingAddressApi from './billingAddressApi';
import * as ContainerApi from './containerApi';
import * as FaerbungReviewApi from './faerbungReviewApi';
import * as AuswertungSettingApi from './auswertungSettingApi';

type ApiType = typeof api;
type SurveyApiType = typeof SurveyApi;
type TrialApiType = typeof TrialApi;
type InvoiceAndPaymentApi = typeof InvoiceAndpaymentApi;
type CertificateApiType = typeof CertificateApi;
type ReviewApiType = typeof ReviewApi;
type UserApiType = typeof UserApi;
type VoucherApiType = typeof VoucherApi;
type EnrollmentApi = typeof EnrollmentApi;
type FeedbackApiType = typeof FeedbackApi;
type InstituteApiType = typeof InstituteApi;
type GroundTruthApiType = typeof GroundTruthApi;
type SubmissionApiType = typeof SubmissionApi;
type DigitalTrialApiType = typeof DigitalTrialApi;
type TrialTagApiType = typeof TrialTagApi;
type BillingAddressApiType = typeof BillingAddressApi;
type ContainerApiType = typeof ContainerApi;
type FaerbungReiewApiType = typeof FaerbungReviewApi;
type AuswertungSettingApiType = typeof AuswertungSettingApi;

type ApiClient =
  ApiType &
  SurveyApiType &
  TrialApiType &
  CertificateApiType &
  ReviewApiType &
  InvoiceAndPaymentApi &
  VoucherApiType &
  UserApiType &
  EnrollmentApi &
  FeedbackApiType &
  InstituteApiType &
  GroundTruthApiType &
  SubmissionApiType &
  DigitalTrialApiType &
  BillingAddressApiType &
  TrialTagApiType &
  FaerbungReiewApiType &
  AuswertungSettingApiType &
  ContainerApiType;

const ApiClient: ApiClient = {
  ...api,
  ...SurveyApi,
  ...TrialApi,
  ...InvoiceAndpaymentApi,
  ...CertificateApi,
  ...ReviewApi,
  ...UserApi,
  ...VoucherApi,
  ...EnrollmentApi,
  ...FeedbackApi,
  ...InstituteApi,
  ...GroundTruthApi,
  ...SubmissionApi,
  ...DigitalTrialApi,
  ...BillingAddressApi,
  ...TrialTagApi,
  ...FaerbungReviewApi,
  ...AuswertungSettingApi,
  ...ContainerApi,
};

export default ApiClient;
